import React, { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Bookmark, BookmarkBorder } from "@mui/icons-material";
import useApp from "../../store/contexts/AppContext";
import CUSTOM_EVENTS from "../../constants/customEvents";

const BookmarkButton = ({ roomId, size = "medium", color = "default" }) => {
  const {
    bookmarkRoomApiCall,
    unbookmarkRoomApiCall,
    checkRoomBookmarkStatusApiCall,
  } = useApp();

  const [isBookmarked, setIsBookmarked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (roomId) {
      checkBookmarkStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId]);

  // Listen for bookmark changes via custom browser event from AppContext
  useEffect(() => {
    const handleBookmarkChange = (event) => {
      const { roomId: eventRoomId, bookmarked } = event.detail;
      if (eventRoomId?.toString() === roomId?.toString()) {
        setIsBookmarked(bookmarked);
      }
    };

    window.addEventListener(CUSTOM_EVENTS.ROOM_BOOKMARK_CHANGED, handleBookmarkChange);

    return () => {
      window.removeEventListener(CUSTOM_EVENTS.ROOM_BOOKMARK_CHANGED, handleBookmarkChange);
    };
  }, [roomId]);

  const checkBookmarkStatus = async () => {
    const result = await checkRoomBookmarkStatusApiCall(roomId);
    if (result.success) {
      setIsBookmarked(result.isBookmarked);
    }
  };

  const handleToggleBookmark = async (e) => {
    e?.stopPropagation();

    if (loading) return;

    setLoading(true);
    try {
      if (isBookmarked) {
        await unbookmarkRoomApiCall(roomId);
        // State will be updated via socket event -> browser event
      } else {
        await bookmarkRoomApiCall(roomId);
        // State will be updated via socket event -> browser event
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title={isBookmarked ? "Remove bookmark" : "Bookmark room"}>
      <span>
        <IconButton
          onClick={handleToggleBookmark}
          disabled={loading}
          size={size}
          sx={{ color }}
        >
          {isBookmarked ? <Bookmark /> : <BookmarkBorder />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default BookmarkButton;
